

define(['angular', 'jquery', 'components/xo-beaver/dist/logger', './fpti', './button', 'xo-models/src/auth'], function (angular, $) {
    angular.module('tracking.listener', ['beaver', 'tracking.fpti', 'button.tracking']).run(function ($rootScope, $logger, $CalDataModel, $AuthModel, $fpti, $fptiError, $FptiConstants, $ButtonTrackingService, $timeout, $FptiBuilder, $meta, $config, $experiment, $util) {
        // eslint-disable-line max-statements

        function logTransition(state) {
            return !(state.trackingData && state.trackingData.suppressTransitionLog);
        }

        function logStateExit(state) {
            return state.trackingData && state.trackingData.trackStateExit;
        }

        function getBeaconUrl() {
            // Logic to switch between production/staging urls. This way we don't pollute live logs,
            // and we are able to test on stage using the fpti log viewing tool.
            return $config.deploy.isLocal() || $config.deploy.isStage() ? 'https://tracking.qa.paypal.com/webapps/tracking/ts' // stage url
            : $config.urls && $config.urls.fptiBeaconUrl;
        }

        /*
         * Triggers pa.js recordClick with custom parameters
         */
        function fptiCustomRecordClick(route, customData) {
            var analyticsInstance, fptiData, fptiDataObj;
            var PAYPAL = window.PAYPAL;

            if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
                PAYPAL.core = PAYPAL.core || {};

                analyticsInstance = new PAYPAL.analytics.Analytics();

                fptiData = new $FptiBuilder({
                    trackingData: route.trackingData,
                    isInContext: $rootScope.miniBrowser,
                    comp: 'hermesnodeweb'
                    // ... Other flow data pass-in here to resolve page qualifier
                }).build();

                // Grab the fpti data object and extend with custom params
                // The fpti data obj should include pxp params as well
                fptiDataObj = fptiData._dataObj;
                $.extend(fptiDataObj, customData);

                analyticsInstance.setRequestData(fptiDataObj);
                analyticsInstance.recordClick({
                    url: getBeaconUrl()
                });
            }
        }

        $rootScope.$on('trackInput', function (event, trackInput) {
            if (!trackInput) {
                return;
            }
            var customData = {
                link: trackInput.transition,
                page: trackInput.page
            };

            fptiCustomRecordClick(trackInput.currentRoute, customData);
        });

        $rootScope.$on('trackClick', function (event, trackClick) {
            if (!trackClick) {
                return;
            }

            var customData = {
                link: trackClick.transition
            };

            fptiCustomRecordClick(trackClick.currentRoute, customData);
        });

        $rootScope.$on('trackSubmit', function (event, trackSubmit) {
            if (!trackSubmit) {
                return;
            }
            var currentRoute = trackSubmit.currentRoute;
            var routeName = currentRoute ? currentRoute.name : 'noRoute';

            $logger.info('track_submit', {
                route_name: routeName
                // ID stuff here later
            });

            if (logTransition(currentRoute)) {
                routeName = routeName.replace(/\./g, '_');
                var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
                var transition = trackSubmit.transition || state;

                $logger.info(routeName + '_exit', {
                    fptiState: state,
                    fptiTransition: transition
                });
            }

            if (trackSubmit.errors && trackSubmit.errors.length) {
                var fptiFieldErrors = JSON.stringify(trackSubmit.errors);

                $logger.info('checkout_fpti', {
                    form_field_errors: fptiFieldErrors
                });
            }

            var errors = trackSubmit.errors;

            if (angular.isArray(errors)) {
                errors.forEach(function (err) {
                    $logger.debug('track_submit_error', err);
                    if ($fpti) {
                        $fpti.setupDataString(currentRoute, new $fptiError({
                            type: 'fieldError',
                            field: err.fieldName,
                            code: err.errorMessage
                        }));
                    }
                });

                if (errors.length) {
                    $logger.flush(true);
                }
            }
        });

        $rootScope.$on('unhandled_error', function (event, exception) {
            if ($fpti) {
                $fpti.setupDataString(exception.currentRoute, new $fptiError({
                    type: 'pageError',
                    message: exception.message,
                    code: exception.cause
                }));
            }
        });

        $rootScope.$on('trackLink', function (event, trackLink) {
            if (!trackLink) {
                return;
            }

            var currentRoute = trackLink.currentRoute;
            var routeName = (currentRoute ? currentRoute.name : 'noRoute').replace(/\./g, '_');
            var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;

            $logger.info(routeName + '_exit', {
                fptiState: state,
                fptiTransition: trackLink.transition
            });
        });

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {

            var from = fromState.name.replace(/\./g, '_');
            var to = toState.name.replace(/\./g, '_');

            if (from && logTransition(fromState) && logStateExit(fromState)) {
                var trackingData = fromState.trackingData && fromState.trackingData || {};

                $logger.info(from + '_exit', { fptiState: trackingData.fptiState || from, fptiTransition: trackingData.fptiState || from });
            }

            $logger.info('state_change', {
                from: from || 'start',
                to: to || 'end'
            });

            // Generate a new CAL correlation_id to be shared until next flow transition (only for view states)
            if (toState.template) {
                $CalDataModel.generateMetaIds();
            }

            $rootScope.currentState = to;

            if (to && logTransition(toState)) {
                $logger.info(to + '_enter', { fptiState: toState.trackingData && toState.trackingData.fptiState || to });
            }
        });

        $rootScope.$on('page_loaded', function (event, from, to) {
            if (from !== 'checkout_init') {
                return;
            }
            var key = $FptiConstants.stateName[to] || 'review';
            var landing_page = $FptiConstants.landing_page[key];

            $logger.info('landing_page', {
                'from': landing_page,
                'to': 'process_page_loaded',
                fpti_landing_page: landing_page
            });
        });

        $rootScope.$on('page_reloaded', function () {
            $logger.flush(true);
            $CalDataModel.generateMetaIds();
        });

        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
            var to = toState.name.replace(/\./g, '_');

            if (toState.hasResolver && to) {
                $logger.info(to + '_load');
            } else if (to) {
                $logger.info(to + '_rendering');
            }
        });

        $rootScope.$on('addrDiff', function (event, addrDiff) {
            if (!addrDiff) {
                return;
            }

            $logger.info('checkout_fpti', addrDiff);
        });

        function getHash(url) {
            if (!url || !~url.indexOf('#')) {
                // eslint-disable-line no-bitwise
                return;
            }

            url = url.split('#');
            return url[url.length - 1];
        }

        var oldHash = window.location.hash;

        window.addEventListener('hashchange', function (event) {
            $logger.info('hashchange', {
                from: getHash(event.oldURL || oldHash),
                to: getHash(event.newURL || window.location.hash)
            });
            oldHash = window.location.hash;
        });

        $(document).on('click', function (event) {
            if (event && event.target && event.target.tagName) {
                var name = event.target.tagName.toLowerCase();

                if (event.target.id) {
                    name += '#' + event.target.id;
                } else if (event.target.attributes && event.target.attributes['ng-model']) {
                    name += ':' + event.target.attributes['ng-model'].value;
                } else if (event.target.className) {
                    name += '.' + event.target.className.split(' ').join('.');
                }

                $logger.info('click', {
                    el: name
                });
            }
        });

        var cplSettings = $config.enableCPL;

        var token = window.meta.token;

        var addTrackingData = function addTrackingData(object) {
            return $util.extend(object, {
                dc: $meta.dc,
                az: $meta.az,
                cust: $AuthModel.instance().buyer_id || '',
                comp: 'hermesnodeweb'
            });
        };

        var passesCplThrottle = cplSettings && (typeof cplSettings.throttle === 'undefined' || $experiment('cpl_tracking', cplSettings.throttle, token));

        if (passesCplThrottle || $util.params().forceEnableCPL) {

            window.fptiserverurl = getBeaconUrl();

            var firstInvocation = true;
            var trackPageStart = function trackPageStart() {
                if (firstInvocation) {
                    firstInvocation = false;
                    return;
                }
                try {
                    window.PAYPAL.analytics.startCPLTracking();
                } catch (e) {
                    console.log('error starting cpl tracking', e);
                }
            };

            var firstDone = true;
            var trackDone = function trackDone(beaconData) {
                window.PAYPAL.analytics.endCPLTracking({
                    pageData: addTrackingData(beaconData),
                    inferStart: firstDone
                });
                firstDone = false;
            };

            var currentRoute = null;

            $rootScope.$on('startLoad', function () {
                return trackPageStart();
            });

            $rootScope.$on('$stateChangeSuccess', function (e, route) {
                currentRoute = route;
            });

            $rootScope.$on('allLoaded', function () {
                try {
                    var buildParams = {
                        productOverride: window.fptiProductOverride,
                        trackingData: $fpti.getPageTrackingData(currentRoute)
                    };

                    var legacyFptiData = new $FptiBuilder(buildParams).build()._dataObj;

                    var product = window.fptiProductOverride || 'ec';

                    legacyFptiData.pgrp = 'main:' + product + ':hermes';

                    legacyFptiData.flid = token;

                    trackDone(legacyFptiData);
                } catch (e) {
                    console.log('error tracking CPL data', e);
                }
            });
        } else {
            $rootScope.$on('$transition', function (event, data) {

                $timeout(function () {
                    if ($fpti) {
                        var fptiData = $fpti.setupDataString(data.toState, null, addTrackingData({
                            transition_time: data.duration
                        }));

                        // Fire and forget button tracking beacon.
                        $ButtonTrackingService.fireBeacon(fptiData);
                    }
                });
            });
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-tracking/dist/listener.js
// module id = ./components/xo-tracking/dist/listener.js
// module chunks = 1